import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import * as serviceWorkerRegistration from './serviceWorkerRegistration.ts';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register({
	onUpdate: (registration) => {
		if (registration.waiting) {
			registration.waiting.postMessage({ type: 'SKIP_WAITING' });
			window.location.reload();
		}
	},
});